import { useApiClient, useFetch } from '@marageti/z4-lib';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import MyProfileFormView from './my-profile-form-view';
import debugPromise from '../../utils/debug-promise';

type MyProfileFormContainerProps = {
  travelerId: string | undefined
  onCancel: () => void
  onSuccess?: () => void
};

const MyProfileFormContainer = ({ travelerId, onCancel, onSuccess = undefined }: MyProfileFormContainerProps) => {
  const { enqueueSnackbar } = useSnackbar();
  const apiClient = useApiClient();
  const {
    data: traveler, isLoading: travelerIsLoading, error: travelerError, mutate: mutateTraveler,
  } = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);
  const [submissionError, setSubmissionError] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    setSubmissionError(false);

    try {
      if (!traveler) {
        throw new Error('No traveler ID');
      }

      await apiClient.peopleClient.putTraveler(traveler.id, {
        ...traveler,
        givenName: values.givenName,
        familyName: values.familyName,
        phone: values.phone,
        countryOfResidence: values.countryOfResidence,
        timeZone: values.timeZone,
      });

      debugPromise('myProfileFormContainer:submit.mutateTraveler', mutateTraveler());
      enqueueSnackbar('Profile updated', { variant: 'success' });
      onSuccess?.();
    } catch (error: any) {
      setSubmissionError(true);
    }
  };

  const isLoading = travelerIsLoading;
  const isError = !!travelerError;

  return (
    <MyProfileFormView
      isLoading={isLoading}
      isError={isError}
      traveler={traveler}
      submissionError={submissionError}
      handleSubmit={handleSubmit}
      onCancel={onCancel}
    />
  );
};

export default MyProfileFormContainer;
